import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { getConfig } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit {
  date: Date = new Date();

  public APP_NAME: string
  public DEVELOPER: string
  public DEVELOPER_LINK: string
  public VERSION: string

  public CAN_UNLOCK: boolean
  public CAN_REGISTER: boolean

  constructor(private router: Router, private helpers: HelpersService) {
    this.APP_NAME = getConfig("app_title");
    this.DEVELOPER = getConfig("app_developer");
    this.DEVELOPER_LINK = getConfig("app_developer_link");
    this.VERSION = getConfig("app_version");

    this.CAN_UNLOCK = getConfig("users_can_unlock_their_own_user");
    this.CAN_REGISTER = getConfig("users_can_register_themselves");
  }

  ngOnInit() {
  }
  ngOnDestroy() {
  }
}
